export default __webpack_public_path__ + "static/media/4.877df74b.jpg";